import { alpha, styled } from '@mui/material/styles';
export const CustomContentRoot = styled('div')(({ theme }) => ({
    WebkitTapHighlightColor: 'transparent',
    ['&:hover, &.Mui-disabled, &.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused, &.Mui-selected:hover']: {
        backgroundColor: 'transparent',
    },
    [`& .MuiTreeItem-contentBar`]: {
        '&:hover &': {
            backgroundColor: theme.palette.action.hover, // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': { backgroundColor: 'transparent' },
        },
        '&.Mui-disabled &': {
            opacity: theme.palette.action.disabledOpacity,
            backgroundColor: 'transparent',
        },
        '&.Mui-focused &': { backgroundColor: theme.palette.action.focus },
        '&.Mui-selected &': {
            backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
        },
        '&.Mui-selected:hover &': {
            backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity), // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            },
        },
        '&.Mui-selected.Mui-focused &': {
            backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity),
        },
    },
}));
